import React, { createContext, useContext, useState } from 'react'

import { IPrimeiroAgendamentoContext, IPrimeiroAgendamentoProvider } from '../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/PrimeiroAgendamentoContext'
import { TermoResponsabilidade } from '../../../../interfaces/entities/TermoResponsabilidade'

const PrimeiroAgendamentoContext = createContext<IPrimeiroAgendamentoContext>(
  {} as IPrimeiroAgendamentoContext
)

const PrimeiroAgendamentoProvider = ({
  children
}: IPrimeiroAgendamentoProvider) => {
  const [termoResponsabilidade, setTermoResponsabilidade] = useState<TermoResponsabilidade | null>(null)
  const [steps, setSteps] = useState<number>(0)
  const [agreed, setAgreed] = useState<boolean>(false);
  const [tabs, setTabs] = useState<number>(0);

  const value = React.useMemo(
    () => ({
      termoResponsabilidade,
      setTermoResponsabilidade,
      steps,
      setSteps,
      agreed,
      setAgreed,
      tabs,
       setTabs
    }),
    [
      termoResponsabilidade,
      setTermoResponsabilidade,
      steps,
      setSteps,
      agreed,
      setAgreed,
      tabs,
      setTabs
    ]
  )

  return (
    <PrimeiroAgendamentoContext.Provider value={value}>
      {children}
    </PrimeiroAgendamentoContext.Provider>
  )
}

const usePrimeiroAgendamentoContext = () => {
  const context = useContext(PrimeiroAgendamentoContext)
  return context
}

export { usePrimeiroAgendamentoContext, PrimeiroAgendamentoProvider }
